import { ArrowPathIcon } from '@gto/icons-react/solid/arrow-path'
import { Button } from '@gto/ui/button'

import { type DataTableDivider, dataTableLoadMoreErrorVariants } from './data-table.styles'
import {
  type DataTableStateCopy,
  DEFAULT_LOAD_MORE_ERROR_MESSAGE,
  DEFAULT_RETRY_LABEL,
} from './state-overlay'

/**
 * Bottom-of-list inline retry for a failed next-page fetch — replaces the analyze
 * table's silent `catch(console.error)` (`no-silent-failures`), `loadMoreError` stays
 * inspectable. Rendered after the last row inside the scroll flow (not an absolute
 * overlay) so it never corrupts `getTotalSize()` / `aria-rowcount` / scroll math.
 */
export type LoadMoreErrorStateProps = {
  onRetry?: () => void
  copy?: DataTableStateCopy
  /** The table's row-separator model — the strip's top line matches the rows above it. */
  divider?: DataTableDivider
}

export const LoadMoreErrorState = ({ onRetry, copy, divider }: LoadMoreErrorStateProps) => (
  <div
    className={dataTableLoadMoreErrorVariants({ divider })}
    data-table-state="load-more-error"
  >
    <span className="text-sm text-error-main">
      {copy?.loadMoreErrorMessage ?? DEFAULT_LOAD_MORE_ERROR_MESSAGE}
    </span>
    {onRetry !== undefined && (
      <Button
        size="small"
        startIcon={<ArrowPathIcon />}
        variant="outlined"
        onClick={onRetry}
      >
        {copy?.loadMoreRetryLabel ?? DEFAULT_RETRY_LABEL}
      </Button>
    )}
  </div>
)
